module.exports = __webpack_public_path__ + "img/9.352d92d1.jpg";